import { render } from "./OnboardingWelcome.vue?vue&type=template&id=edd8212a&scoped=true&ts=true"
import script from "./OnboardingWelcome.vue?vue&type=script&lang=ts"
export * from "./OnboardingWelcome.vue?vue&type=script&lang=ts"

import "./OnboardingWelcome.vue?vue&type=style&index=0&id=edd8212a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.27_typescript@5.9.3__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd8212a"]])

export default __exports__